import { useUser } from "@clerk/clerk-react"
import { ClerkPublicMetadata } from "../types/clerk-metadata"

export function useIsAskAdmin() {
  const { user, isLoaded } = useUser()

  if (!isLoaded || !user) {
    return { isAdmin: false, isLoaded: false, tenantId: null }
  }

  const publicMetadata = user.publicMetadata as ClerkPublicMetadata
  const askMetadata = publicMetadata.ask

  // Check if user has Ask access and is admin
  const isAdmin = askMetadata?.active === true && askMetadata?.admin === true
  const tenantId = askMetadata?.tenantId || null

  return { isAdmin, isLoaded: true, tenantId }
}
